import React, { useRef, useState } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import ClickAwayListener from 'react-click-away-listener';
import { Button, SelectInput } from '@ui';
import { translate } from '@utils/i18n';
import './DnvTypeSelectorStyles.scss';
const namespace = 'features.settings.component_types';
// Single DNV value picker for Component Type, styled to match the sibling
// EpCodeSelector: a wide native dropdown on the create modal, and a two-column
// (label + greyish inline dropdown) inline-edit control on the detail modal.
// The option list mirrors Equipment Type's DNV enum (passed from the backend).
function DnvTypeSelector({ dnvType, options, onChange, variant = 'create' }) {
    var _a;
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const selectedLabel = ((_a = options.find((option) => option.value === dnvType)) === null || _a === void 0 ? void 0 : _a.label) || '';
    if (variant === 'edit') {
        return (React.createElement("div", { className: "dnv-type-selector --edit" },
            React.createElement("div", { className: "form-field" },
                React.createElement("label", { className: "form-field__label", id: "dnv-type-label" }, translate('dnv_type', { namespace })),
                React.createElement("button", { ref: dropdownRef, type: "button", className: "qmb-inedit --dropdown", "aria-labelledby": "dnv-type-label", onClick: () => setDropdownOpen(true) },
                    React.createElement("span", { className: "selectValue" }, selectedLabel || translate('select_an_option', { namespace: 'features.commons' }))),
                React.createElement(Popup, { anchor: dropdownRef.current, show: dropdownOpen },
                    React.createElement(ClickAwayListener, { onClickAway: () => setDropdownOpen(false) },
                        React.createElement("div", { className: "dnv-type-dropdown-popup" },
                            React.createElement("div", { className: "dnv-type-dropdown-popup__list" },
                                selectedLabel && (React.createElement(Button, { key: "clear", className: "qmb-control qmb-control--clear", onClick: () => {
                                        setDropdownOpen(false);
                                        onChange(null);
                                    } },
                                    React.createElement("i", { className: "fa-light fa-xmark" }),
                                    " ",
                                    translate('clear_dnv_type', { namespace }))),
                                options.map((option) => (React.createElement(Button, { key: option.value, className: "qmb-control", onClick: () => {
                                        setDropdownOpen(false);
                                        onChange(option.value);
                                    } }, option.label))))))))));
    }
    const selectOptions = [
        { value: '', label: translate('select_an_option', { namespace: 'features.commons' }) },
        ...options
    ];
    return (React.createElement("div", { className: "dnv-type-selector" },
        React.createElement("div", { className: "dnv-type-selector__input" },
            React.createElement(SelectInput, { id: "component-type-dnv-type", label: translate('dnv_type', { namespace }), value: dnvType !== null && dnvType !== void 0 ? dnvType : '', options: selectOptions, onChange: (value) => onChange(value || null) }))));
}
export default DnvTypeSelector;
